export default __webpack_public_path__ + "static/media/avatar_118.eb5e404f.png";